
import { Vue, Prop, Component, Watch} from "vue-property-decorator";
import { cloneDeep } from "lodash-es";
import moment from "moment";

import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselect.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import UserLocationsMultiselect from "@/components/autocompleteMultiselects/UserLocationsMultiselect.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInput.vue";

import { Manager } from "@/generated/graphql";

import ManagerRadioButtonOptions from "@/entities/scheduler/ManagerRadioButtonOptions";;
import RadioOption from "@/entities/RadioOption";
import managerViewFiltersTemplate from "@/data/filtersTemplates/scheduler/managerViewFIltersTemplate";
import ManagerAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ManagerAdditionalFilters";
import DateRange from "@/entities/scheduler/DateRange";
import CompanyScheduler from "@/views/scheduler/CompanyScheduler.vue";
import FormDateRangePicker from "../../form/FormDateRangePicker.vue";
import UiButton from "@/components/button/ui-button.vue";

@Component({
  components: {
    ManagersMultiselect,
    FormGroup,
    UserLocationsMultiselect,
    RadioButtonGroup,
    ProfileCountrySelect,
    RegionInput,
    UserCityMultiselect,
    CompanyScheduler,
    FormDateRangePicker,
    UiButton
  },
})
export default class ManagerViewAdditionalFilters extends Vue {
  @Prop({ type: Boolean, default: false }) readonly shouldClearFilters!: boolean;

  filterFields: ManagerAdditionalFilters = cloneDeep(managerViewFiltersTemplate);
  managerProjects: Manager[] = [];
  rangeStart: Date = new Date();
  rangeEnd: Date = moment(this.rangeStart).add(1, 'M').toDate();

  radiobuttonOptions: RadioOption[] = [{
    label: "Highest",
    value: ManagerRadioButtonOptions.MOST_PROJECTS_FIRST,
  },
  {
    label: "Lowest",
    value: ManagerRadioButtonOptions.LEAST_PROJECTS_FIRST,
  }];

  created(): void {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }

  @Watch("shouldClearFilters")
  handleClearFilters(value: boolean): void {
    if (value === true) {
      this.clearFilters();
      this.$emit("filtersReset");
    }
  }

  @Watch("numberOfAppliedFilters", { immediate: true })
  appliedFiltersNumberChanged() {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }

  @Watch("dateRange")
  handleDateRange() {
    this.$emit("rangeStart", this.rangeStart)
    this.$emit("rangeEnd", this.rangeEnd)
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      orderByChosenOption: this.filterFields.orderByChosenOption,
    })
  }

  get numberOfAppliedFilters(): any {
    const appliedFiltersQuantity = {
      countries: this.filterFields.countries.length ? 1 : 0,
      states: this.filterFields.states.length ? 1 : 0,
      cities: this.filterFields.cities.length ? 1 : 0,
      orderBy: this.filterFields.orderByChosenOption
        && this.filterFields.orderByChosenOption !== ManagerRadioButtonOptions.MOST_PROJECTS_FIRST ? 1 : 0,
    }

    return Object.values(appliedFiltersQuantity)
      .reduce((prevValue, curValue) => {
        return prevValue + curValue;
      }, 0);
  }

  get countriesNames(): string[] {
    return this.filterFields.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.filterFields.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.filterFields.cities.map((city) => city.name);
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.filterFields.orderByChosenOption,
      this.countriesNames,
      this.statesNames,
      this.citiesNames,
    ]);
  }

  get dateRange(): DateRange {
    return {
      startDate: this.rangeStart,
      endDate: this.rangeEnd,
    }
  }

 handleDateRangeChange(date: DateRange) {
    this.rangeStart = date.startDate;
    this.rangeEnd = date.endDate;
  }

  handleOrderByInput(value: string): void {
    const chosenOption = this.radiobuttonOptions.filter(option => option.value === value)[0];
    this.filterFields.orderByChosenOption = chosenOption.value as ManagerRadioButtonOptions;
  }

  clearFilters(): void {
    this.filterFields = cloneDeep(managerViewFiltersTemplate);
  }

  closeModal(): void{
    this.$emit('close')
  }
}
